export interface IQueryParamGroup {
  // Name of the query param group
  name: string;
  subtitle?: string;
  // List of query param categories
  queryParamCategories: IQueryParamCategory[];
}

// The element type to render for each query param category
export enum EQueryParamCategoryElementType {
  DROPDOWN = 0,
  CHIPS = 1,
  SLIDER = 2,
}

export interface IQueryParamCategory {
  // Title of the category
  title: string;

  // A subtitle that will be displayed below the title
  subTitle?: string;

  // The type of element to display
  elementType: EQueryParamCategoryElementType;

  // Description of the param category
  description?: string;

  // Can the user select more than one element?
  multiSelect: boolean;

  // Can the user deselect an element or is it mandatory to have one selected?
  mandatory: boolean;

  // List of query params in this category
  queryParams: IQueryParam[];

  // Whether to make the category visible and selectable on the endpoint builder
  display: boolean;
}

export interface IQueryParam {
  // Name of the query param that will be used in the URL
  paramName: string;

  // Value of the query param that will be used in the URL
  paramValue: string;

  // The text to be displayed in the UI for the query param
  text: string;

  // an optional list of other params that cannot be selected alongside this param in dependency selections
  exclusions?: string[];
}
